import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 30000,
});

// Request interceptor to add token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // 显示提示后再跳转，避免静默跳转让用户以为网站崩了
      const msg = error.response?.data?.error || '登录已过期，请重新登录';
      // 用原生 toast 避免循环依赖（React 上下文此时可能已卸载）
      const el = document.createElement('div');
      el.textContent = msg;
      Object.assign(el.style, {
        position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)',
        background: '#ff3b30', color: '#fff', padding: '12px 24px',
        borderRadius: '12px', fontSize: '14px', fontWeight: '600',
        zIndex: '99999', boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        whiteSpace: 'nowrap'
      });
      document.body.appendChild(el);
      setTimeout(() => {
        document.body.removeChild(el);
        window.location.href = '/login';
      }, 1800);
    }
    // 维护模式：后端对非管理员返回 503 + code:'MAINTENANCE'，通知 MaintenanceGate 立即显示全屏提示
    if (error.response?.status === 503 && error.response?.data?.code === 'MAINTENANCE') {
      window.dispatchEvent(new Event('maintenance:on'));
    }
    return Promise.reject(error);
  }
);

export default api;
